import React, { Component } from 'react'

import PageLayout from '../layout/PageLayout'
import TicketsSeller from '../components/TicketsSeller'


class BookingPage extends Component {

    render() {
        return (
            <PageLayout isEmbedded={this.props.isEmbedded}>
                <TicketsSeller 
                        performanceId={this.props.match.params.performanceId}
                        eventId={this.props.match.params.eventId}
                    />
            </PageLayout>
        )
    }
}

export default BookingPage;